import { createContext } from 'react';

import type { KeyboardEvent } from '../../core/types/events.js';

/** @internal */
interface TerminologyOverlayContextType {
  isDisabled?: boolean;
  'aria-expanded'?: boolean | 'true' | 'false';
  'aria-haspopup'?:
    | boolean
    | 'menu'
    | 'listbox'
    | 'tree'
    | 'grid'
    | 'dialog'
    | 'true'
    | 'false';
  'aria-controls'?: string;
  'data-state'?: 'open' | 'closed';
  onKeyDown?: (e: KeyboardEvent) => void;
}

export const TerminologyOverlayContext =
  createContext<TerminologyOverlayContextType>({});
